// ProjectContributorCard.jsx
import React from 'react';
import axios from '../../config/axiosClient';
import Config from '../../config/Config.js';

class ProjectContributorCard extends React.Component {
  constructor(props){
    super(props);
    this.state = { user: {}, extended_user: {} };
  }

  componentDidMount() {
    axios.get(`${Config().userUrl}${this.props.user_id}`)
      .then(res1 => {
        const user = res1.data;
        axios.get(`${Config().extendedUserUrl}?user=${this.props.user_id}`)
          .then(res2 => {
            const data = res2.data;
            const results = Array.isArray(data) ? data : data.results || [];
            this.setState({ user, extended_user: results[0] || {} });
          })
          .catch(() => {
            this.setState({ user, extended_user: {} });
          });
      })
      .catch(err => {
        console.error('ProjectContributorCard User Load Error:', err);
        this.setState({ user: {}, extended_user: {} });
      });
  }

  render() {
    const { user, extended_user } = this.state;
    const avatarSrc = extended_user.picture_link || '/img/avatar-fallback.png';

    return (
      <div className="contrib-card">
        <a href={`/${user.username}`} className="contrib-link">
          <span className="avatar-wrap">
            <img
              className="contrib-avatar"
              src={avatarSrc}
              alt={`${user.first_name || ''} ${user.last_name || ''}`.trim() || user.username || 'User avatar'}
              loading="lazy"
              referrerPolicy="no-referrer"
            />
          </span>
          <span className="contrib-name">
            {user.first_name && <span>{user.first_name}</span>}
            {user.last_name && <br />}
            {user.last_name && <span>{user.last_name}</span>}
            </span>
        </a>
      </div>
    );
  }
}

export default ProjectContributorCard;
